import { CreateLeadDto } from '@interfaces/crm';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/crm';

export const createLead = async (dto: CreateLeadDto) =>
  fetcher(`${API_URL}/createLead`, { method: 'POST', body: dto });

export const updateLeadBotConfigured = async () =>
  fetcher(`${API_URL}/updateLeadBotConfigured`, { method: 'POST' });
